"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("../Button"));
var _Text = _interopRequireDefault(require("../Text"));
var _Cross = _interopRequireDefault(require("../Icon/Icons/Cross"));
var _style = require("./style");
var _colors = require("../style/colors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class Banner extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: true
    };
    this.closeBanner = this.closeBanner.bind(this);
  }
  closeBanner() {
    this.setState({
      isOpen: false
    });
    const {
      onCloseBanner
    } = this.props;
    if (onCloseBanner) {
      onCloseBanner();
    }
  }
  renderBannerContent(themeColor) {
    const {
      customHTML,
      text,
      actionButton
    } = this.props;
    if (customHTML) {
      return /*#__PURE__*/_react.default.createElement(_style.Wrapper, null, /*#__PURE__*/_react.default.createElement("div", {
        dangerouslySetInnerHTML: customHTML
      }));
    }
    return /*#__PURE__*/_react.default.createElement(_style.Wrapper, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      type: "paragraph",
      color: "#FFF"
    }, text), /*#__PURE__*/_react.default.createElement(_style.ButtonWrapper, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: themeColor === 'orange' ? 'orange' : 'primary',
      onClick: actionButton.action,
      label: actionButton.label,
      size: "small"
    })));
  }
  render() {
    const {
      isOpen
    } = this.state;
    const {
      themeColor
    } = this.props;
    if (isOpen) {
      return /*#__PURE__*/_react.default.createElement(_style.BannerStyled, {
        themeColor: themeColor
      }, this.renderBannerContent(themeColor), /*#__PURE__*/_react.default.createElement(_style.BannerCloseButton, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
        type: "text",
        icon: /*#__PURE__*/_react.default.createElement(_Cross.default, {
          color: themeColor === 'blue' ? '#fff' : _colors.orangeDarker
        }),
        hasIconOnly: true,
        onClick: this.closeBanner,
        label: "Close",
        size: "small"
      })));
    }
    return null;
  }
}
exports.default = Banner;
Banner.propTypes = {
  text: _propTypes.default.string,
  actionButton: _propTypes.default.shape({
    label: _propTypes.default.string,
    action: _propTypes.default.func
  }),
  customHTML: _propTypes.default.shape({
    __html: _propTypes.default.string
  }),
  themeColor: _propTypes.default.oneOf(['blue', 'orange']),
  onCloseBanner: _propTypes.default.func
};
Banner.defaultProps = {
  text: '',
  actionButton: {},
  customHTML: null,
  themeColor: 'blue',
  onCloseBanner: null
};